import { Box, Stack } from '@mui/material';
import styled from 'styled-components';

export type EmptyTableContentPropsType = {
  message?: string | number;
  iconColor?: string;
  messageColor?: string;
  IconEl?: JSX.Element | any;
};

type WrapperProps = {
  iconColor?: string;
  messageColor?: string;
};

const Wrapper = styled.div<WrapperProps>`
  margin-top: 40px;
  color: green;
  .message {
    font-size: 0.8125rem;
    color: ${(props) => props.messageColor || 'grey'};
  }

  .icon {
    color: ${(props) => props.iconColor || 'green'};
    font-size: 3em;
  }
`;

const EmptyTableContent: React.FC<EmptyTableContentPropsType> = ({
  message,
  messageColor,
  iconColor,
  IconEl,
}) => {
  return (
    <Wrapper className="empty-content-wrapper" messageColor={messageColor} iconColor={iconColor}>
      <Stack
        sx={{
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box className="message">{message}</Box>
        <Box> {IconEl && <IconEl className="icon" />}</Box>
      </Stack>
    </Wrapper>
  );
};

export default EmptyTableContent;
